const initialState = {
	isLoading: 0,
	errors: {},
	success: false
}

export default (state = initialState, action) => {
	switch (action.type){
		case 'ENEWS_IN_PROCESS':
			return {
				...state,
				errors: {},
				isLoading: 1,
				success: false
			}
		case 'ENEWS_HAS_ERROR':
			return {
				...state,
				isLoading: 0,
				errors: action.errors
			}
		case 'ENEWS_SUCCESS':
			return {
				...state,
				isLoading: 0,
				success: true
			}

		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/store/reducers/enews.js